import styled from 'styled-components/native';
import { FontAwesome5 as IconsFA5 } from '@expo/vector-icons';
import { themes } from '../../design/colors';

export const IconFA5 = styled(IconsFA5)`
    color: ${themes.colors.primary};
`;

export const CardInfo = styled.View`
    background-color: #fff;
    margin-top: 10px;
    padding: 15px;
    border-top-left-radius: 5px;
    border-top-right-radius: 5px;
`;

export const TitleCard = styled.View`
    flex-direction: row;
`;

export const NameEncomenda = styled.Text`
    color: ${themes.colors.primary};
    font-size: 14px;
    font-weight: bold;
    padding: 5px;
`;

export const Hr = styled.View`
    border-bottom-color: ${themes.colors.primary};
    border-bottom-width: 1px;
    flex: 1;
    margin: 20px 20px 0 20px;
`;

export const ContentCircle = styled.View`
    justify-content: space-between;
    margin: 0 20px;
    align-items: center; 
    flex-direction: row; 
    margin-top: -5.5px;
`;

export const ColorCircle = styled.View`
    height: 10px;
    width: 10px;
    border-radius: 60px;
    background-color: ${themes.colors.primary};
`;

export const OutlineCircle = styled.View`
    height: 10px;
    width: 10px;
    border-radius: 60px;
    border-top-color: ${themes.colors.primary};
    border-bottom-color: ${themes.colors.primary};
    border-left-color: ${themes.colors.primary};
    border-right-color: ${themes.colors.primary};
    border-width: 1px;
    background-color: #fff;
`;

export const ContainerCircleDescription = styled.View`
    justify-content: space-between;
    flex-direction: row;
`;

export const ContentTextCircleDescription = styled.View``;

export const TextWaiting = styled.Text`
    color: #999999;
    font-size: 8px;
    font-weight: bold;
    margin-top: 8px;
    margin-left: 8px;
`;

export const TextWithdrawalWaiting = styled.Text`
    color: #999999;
    font-size: 8px; 
    font-weight: bold;
`;

export const TextWithdrawal = styled.Text`
    color: #999999;
    font-size: 8px; 
    font-weight: bold; 
    margin-top: 8px; 
    margin-left: -5px;
`;

export const TextDelivered = styled.Text`
    color: #999999; 
    font-size: 8px;
    font-weight: bold;
    margin-top: 8px;
    margin-right: 6px;
`;

export const FooterCard = styled.View`
    flex-direction: row;
    justify-content: space-between;
    background-color: #F8F9FD;
    padding: 15px;
    margin-top: -10px;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
`;

export const ContentFooterCard = styled.View``;

export const TextDate = styled.Text`
    color: #999999;
    font-size: 8px;
    font-weight: bold; 
    margin-top: 8px;
`;

export const Date = styled.Text`
    color: #444444;
    font-size: 12px;
    font-weight: bold;
`;

export const TitleCityName = styled.Text`
    color: #999999;
    font-size: 8px;
    font-weight: bold; 
    margin-top: 8px;
`;

export const CityName = styled.Text`
    color: #444444;
    font-size: 12px;
    font-weight: bold;
`;

export const ViewDetails = styled.Text`
    color: ${themes.colors.primary};
    font-weight: bold;
    margin-top: 13px;
`;